<template>
    <!-- <div class="item" :class="{'on': isSelected}"> -->
    <div class="item" @click="action_Select">
        <span class="color_circle" :style="backgroundColorString"></span>
        <span class="txt ellipsis">{{ title }}</span>
    </div>
</template>


<script>
import { sheetState } from '../../../../../sheet-state'
export default {
    props: {
        state: Object,
        selectedState: Object
    },
    data() {
        return {
            sheetState,
        }
    },
    computed: {
        title: function() {
            return this.state.title
        },
        colorPalette: function() {
            return this.sheetState.reservationSetting?.statusColorPaletteID
        },
        isBasicPalette: function() {
            // TODO: Check
            return true
        },
        basicPalette: function() {
            return this.colorPalette.basicPalette
        },
        customPalette: function() {
            return this.colorPalette.customPalette
        },
        colorIndex: function() {
            // TODO: custom palette index check
            return this.isBasicPalette ? this.state.paletteIndex : 0
        },
        colorString: function() {
            return this.isBasicPalette ? this.basicPalette[this.colorIndex] : this.customPalette[this.colorIndex]
        },
        backgroundColorString: function() {
            return 'background-color: ' + this.colorString + ';'
        },
        isSelected: function() {
            return this.state._id == this.selectedState._id
        }
    },
    methods: {
        action_Select() {
            this.$emit('setSelectedState', this.state)
        }
    }
}
</script>